import React from 'react';
import { Col, Container, FormGroup, Row } from 'reactstrap';
import { ButtonGroup, InputText } from '@/components';
import { FormData, FormErrors, OnChangeFormInput } from '@/hooks';
import { FormInputTaxes } from '../../types';

interface StateProps {
  formData: FormData;
  formErrors: FormErrors;
}

interface DispatchProps {
  onChangeFormInput: OnChangeFormInput;
}

type Props = StateProps & DispatchProps;

export const TaxesContent: React.FC<Props> = ({ formData, onChangeFormInput, formErrors }) => (
  <Container className="mainContainer" fluid={true}>
    <div className="container-event">
      <h5 className="mb-2 border-bottom-title mb-5">Taxas vendas sobre ingresso</h5>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <ButtonGroup
              label="Taxas administrativas"
              name="calcAdmFee"
              value={formData[FormInputTaxes.calcAdmFee]}
              onChange={e => onChangeFormInput(FormInputTaxes.calcAdmFee)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.calcAdmFee && formErrors.calcAdmFee[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="pdv"
              label="Comissão Banca"
              placeholder="1.00%"
              maxLength={5}
              value={formData[FormInputTaxes.pdv]}
              onChange={e => onChangeFormInput(FormInputTaxes.pdv)(e.target.value)}
              error={formErrors.pdv && formErrors.pdv[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-2">
            <ButtonGroup
              label="Comissão sobre venda"
              name="generalCommission"
              value={formData[FormInputTaxes.generalCommission]}
              onChange={e => onChangeFormInput(FormInputTaxes.generalCommission)(e.target.value)}
              options={[
                { value: true, label: 'Geral' },
                { value: false, label: 'PDV' },
              ]}
              error={formErrors.generalCommission && formErrors.generalCommission[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="credit"
              label="Crédito à vista"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.credit]}
              onChange={e => onChangeFormInput(FormInputTaxes.credit)(e.target.value)}
              error={formErrors.credit && formErrors.credit[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="installment"
              label="Crédito parcelado"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.installment]}
              onChange={e => onChangeFormInput(FormInputTaxes.installment)(e.target.value)}
              error={formErrors.installment && formErrors.installment[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="debit"
              label="Débito"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.debit]}
              onChange={e => onChangeFormInput(FormInputTaxes.debit)(e.target.value)}
              error={formErrors.debit && formErrors.debit[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="pix"
              label="Pix"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.pix]}
              onChange={e => onChangeFormInput(FormInputTaxes.pix)(e.target.value)}
              error={formErrors.pix && formErrors.pix[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="bankslip"
              label="Boleto"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.bankslip]}
              onChange={e => onChangeFormInput(FormInputTaxes.bankslip)(e.target.value)}
              error={formErrors.bankslip && formErrors.bankslip[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <h5 className="mb-2 border-bottom-title mb-5">Despesas vendas sobre ingresso</h5>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="food"
              label="Alimentação"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.food]}
              onChange={e => onChangeFormInput(FormInputTaxes.food)(e.target.value)}
              error={formErrors.food && formErrors.food[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="technical"
              label="Técnicos"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.technical]}
              onChange={e => onChangeFormInput(FormInputTaxes.technical)(e.target.value)}
              error={formErrors.technical && formErrors.technical[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="trip"
              label="Viagem"
              placeholder="1.000,00"
              maxLength={10}
              value={formData[FormInputTaxes.trip]}
              onChange={e => onChangeFormInput(FormInputTaxes.trip)(e.target.value)}
              error={formErrors.trip && formErrors.trip[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="rentPos"
              label="Aluguel POS"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.rentPos]}
              onChange={e => onChangeFormInput(FormInputTaxes.rentPos)(e.target.value)}
              error={formErrors.rentPos && formErrors.rentPos[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="courtesyIssuance"
              label="Emisao de cortesia"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.courtesyIssuance]}
              onChange={e => onChangeFormInput(FormInputTaxes.courtesyIssuance)(e.target.value)}
              error={formErrors.courtesyIssuance && formErrors.courtesyIssuance[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="cashSaleDashboard"
              label="Venda em dinheiro ADM/Dashboard"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.cashSaleDashboard]}
              onChange={e => onChangeFormInput(FormInputTaxes.cashSaleDashboard)(e.target.value)}
              error={formErrors.cashSaleDashboard && formErrors.cashSaleDashboard[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="ticketCancellations"
              label="Cancelamentos de ingresso"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.ticketCancellations]}
              onChange={e => onChangeFormInput(FormInputTaxes.ticketCancellations)(e.target.value)}
              error={formErrors.ticketCancellations && formErrors.ticketCancellations[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="blockMap"
              label="Bloqueio de mesa ou cadeira"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.blockMap]}
              onChange={e => onChangeFormInput(FormInputTaxes.blockMap)(e.target.value)}
              error={formErrors.blockMap && formErrors.blockMap[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="releaseMap"
              label="Desbloqueio de mesa ou cadeira"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.releaseMap]}
              onChange={e => onChangeFormInput(FormInputTaxes.releaseMap)(e.target.value)}
              error={formErrors.releaseMap && formErrors.releaseMap[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="ticketRoll"
              label="Bobina POS"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.ticketRoll]}
              onChange={e => onChangeFormInput(FormInputTaxes.ticketRoll)(e.target.value)}
              error={formErrors.ticketRoll && formErrors.ticketRoll[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>

      <h5 className="mb-2 border-bottom-title mb-5">Taxas vendas sobre bar</h5>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <ButtonGroup
              label="Taxas administrativas"
              name="calcAdmFeeProduct"
              value={formData[FormInputTaxes.calcAdmFeeProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.calcAdmFeeProduct)(e.target.value)}
              options={[
                { value: true, label: 'Sim' },
                { value: false, label: 'Não' },
              ]}
              error={formErrors.calcAdmFeeProduct && formErrors.calcAdmFeeProduct[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="pdvProduct"
              label="Comissão Banca"
              placeholder="1.00%"
              maxLength={5}
              value={formData[FormInputTaxes.pdvProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.pdvProduct)(e.target.value)}
              error={formErrors.pdvProduct && formErrors.pdvProduct[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-2">
            <ButtonGroup
              label="Comissão sobre venda"
              name="generalCommissionProduct"
              value={formData[FormInputTaxes.generalCommissionProduct]}
              onChange={e =>
                onChangeFormInput(FormInputTaxes.generalCommissionProduct)(e.target.value)
              }
              options={[
                { value: true, label: 'Geral' },
                { value: false, label: 'PDV' },
              ]}
              error={formErrors.generalCommissionProduct && formErrors.generalCommissionProduct[0]}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="creditProduct"
              label="Crédito à vista"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.creditProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.creditProduct)(e.target.value)}
              error={formErrors.creditProduct && formErrors.creditProduct[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="installmentProduct"
              label="Crédito parcelado"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.installmentProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.installmentProduct)(e.target.value)}
              error={formErrors.installmentProduct && formErrors.installmentProduct[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="debitProduct"
              label="Débito"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.debitProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.debitProduct)(e.target.value)}
              error={formErrors.debitProduct && formErrors.debitProduct[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="pixProduct"
              label="Pix"
              placeholder="2.50%"
              maxLength={5}
              value={formData[FormInputTaxes.pixProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.pixProduct)(e.target.value)}
              error={formErrors.pixProduct && formErrors.pixProduct[0]}
              addon={'%'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="bankSlipProduct"
              label="Boleto"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.bankSlipProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.bankSlipProduct)(e.target.value)}
              error={formErrors.bankSlipProduct && formErrors.bankSlipProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <h5 className="mb-2 border-bottom-title mb-5">Despesas vendas sobre bar</h5>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="foodProduct"
              label="Alimentação"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.foodProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.foodProduct)(e.target.value)}
              error={formErrors.foodProduct && formErrors.foodProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="technicalProduct"
              label="Técnicos"
              placeholder="2,50"
              maxLength={10}
              value={formData[FormInputTaxes.technicalProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.technicalProduct)(e.target.value)}
              error={formErrors.technicalProduct && formErrors.technicalProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="tripProduct"
              label="Viagem"
              placeholder="1.000,00"
              maxLength={10}
              value={formData[FormInputTaxes.tripProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.tripProduct)(e.target.value)}
              error={formErrors.tripProduct && formErrors.tripProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="rentPosProduct"
              label="Aluguel POS"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.rentPosProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.rentPosProduct)(e.target.value)}
              error={formErrors.rentPosProduct && formErrors.rentPosProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="courtesyIssuanceProduct"
              label="Emisao de cortesia"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.courtesyIssuanceProduct]}
              onChange={e =>
                onChangeFormInput(FormInputTaxes.courtesyIssuanceProduct)(e.target.value)
              }
              error={formErrors.courtesyIssuanceProduct && formErrors.courtesyIssuanceProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="cashSaleDashboardProduct"
              label="Venda em dinheiro ADM/Dashboard"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.cashSaleDashboardProduct]}
              onChange={e =>
                onChangeFormInput(FormInputTaxes.cashSaleDashboardProduct)(e.target.value)
              }
              error={formErrors.cashSaleDashboardProduct && formErrors.cashSaleDashboardProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="ticketCancellationsProduct"
              label="Cancelamentos de ingresso"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.ticketCancellationsProduct]}
              onChange={e =>
                onChangeFormInput(FormInputTaxes.ticketCancellationsProduct)(e.target.value)
              }
              error={
                formErrors.ticketCancellationsProduct && formErrors.ticketCancellationsProduct[0]
              }
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup className="mb-2">
            <InputText
              name="ticketRollProduct"
              label="Bobina POS"
              placeholder="80,00"
              maxLength={10}
              value={formData[FormInputTaxes.ticketRollProduct]}
              onChange={e => onChangeFormInput(FormInputTaxes.ticketRollProduct)(e.target.value)}
              error={formErrors.ticketRollProduct && formErrors.ticketRollProduct[0]}
              addon={'R$'}
            />
          </FormGroup>
        </Col>
      </Row>
    </div>
  </Container>
);
